/**
 * پانویسِ مشترکِ همهٔ گزارش‌ها (PDF و چاپ) — «سامانهٔ ArjanPeyman.ir — شرکت ارجان آرایه پویا»
 */
export const REPORT_FOOTER_TEXT = 'سامانهٔ ArjanPeyman.ir — شرکت ارجان آرایه پویا'

/** افزودنِ پانویس به همهٔ صفحاتِ یک سندِ jsPDF (قبل از output/save صدا بزنید). */
export function addPdfFooter(doc, opts = {}) {
  try {
    const font = opts.font || 'Vazir'
    const size = opts.size || 8
    const color = opts.color == null ? 125 : opts.color
    const pages = doc.internal.getNumberOfPages()
    for (let i = 1; i <= pages; i++) {
      doc.setPage(i)
      const w = doc.internal.pageSize.getWidth()
      const h = doc.internal.pageSize.getHeight()
      doc.setFont(font, 'normal')
      doc.setFontSize(size)
      doc.setTextColor(color)
      doc.text(REPORT_FOOTER_TEXT, w / 2, h - 4, { align: 'center' })
      doc.setTextColor(0)
    }
  } catch (e) {
    /* پانویس نباید چاپ را بشکند */
  }
  return doc
}

/** تکه‌HTML پانویس برای پنجره‌های چاپ (window.open). */
export function reportFooterHtml(extraStyle = '') {
  return (
    '<div style="margin-top:14px;padding-top:6px;border-top:1px solid #e2e8f0;' +
    'text-align:center;font-size:9.5px;color:#7a80a3;direction:rtl;' + extraStyle + '">' +
    REPORT_FOOTER_TEXT +
    '</div>'
  )
}
